import { Platform } from 'react-native';
import Constants from 'expo-constants';

export const isDoctorPortal = () => {
  if (Platform.OS !== 'web') {
    return false;
  }

  if (window.location.hostname === 'localhost') {
    return Constants.expoConfig?.extra?.brand === 'portal';
  }

  return window.location.hostname.indexOf('portal.leafdoctors.com.au') > -1;
};
